import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Box, CircularProgress,
} from '@mui/material';
import type {
    DostupnostTechnikaDuvod,
    SetDostupnostTechnikaRequest,
} from '../../api/JsdhNotifikaceService/generated/models/DostupnostTechnika';
import { DUVOD_LABELS } from '../../api/JsdhNotifikaceService/generated/models/DostupnostTechnika';

interface Props {
    open: boolean;
    onClose: () => void;
    vozidloLabel: string;        // napr. "CAS 20 (HOP 626)"
    onSubmit: (data: SetDostupnostTechnikaRequest) => void;
    isPending: boolean;
}

const DostupnostTechnikaDialog: React.FC<Props> = ({ open, onClose, vozidloLabel, onSubmit, isPending }) => {
    const [duvod, setDuvod] = useState<DostupnostTechnikaDuvod>('SERVIS');
    const [platnostOd, setPlatnostOd] = useState('');
    const [platnostDo, setPlatnostDo] = useState('');
    const [poznamka, setPoznamka] = useState('');

    // "Do" musi byt po "Od" — zrcadli serverovou validaci (format YYYY-MM-DDTHH:mm
    // umoznuje bezpecne lexikograficke porovnani)
    const rozsahNeplatny = Boolean(platnostOd && platnostDo && platnostDo <= platnostOd);

    const handleSubmit = () => {
        onSubmit({
            duvod,
            poznamka: poznamka || undefined,
            platnostOd: platnostOd || null,
            platnostDo: platnostDo || null,
        });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Odhlásit {vozidloLabel}</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField
                        select
                        label="Důvod"
                        value={duvod}
                        onChange={(e) => setDuvod(e.target.value as DostupnostTechnikaDuvod)}
                        fullWidth
                        required
                    >
                        {(Object.keys(DUVOD_LABELS) as DostupnostTechnikaDuvod[]).map((d) => (
                            <MenuItem key={d} value={d}>{DUVOD_LABELS[d]}</MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Od (prázdné = od teď)"
                        type="datetime-local"
                        value={platnostOd}
                        onChange={(e) => setPlatnostOd(e.target.value)}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                        label="Do (prázdné = do odvolání)"
                        type="datetime-local"
                        value={platnostDo}
                        onChange={(e) => setPlatnostDo(e.target.value)}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        error={rozsahNeplatny}
                        helperText={rozsahNeplatny
                            ? '„Do" musí být po „Od"'
                            : 'Po uplynutí se vozidlo vrátí do provozu automaticky'}
                    />
                    <TextField
                        label="Poznámka"
                        value={poznamka}
                        onChange={(e) => setPoznamka(e.target.value)}
                        fullWidth
                        inputProps={{ maxLength: 255 }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Zrušit</Button>
                <Button variant="contained" color="warning" onClick={handleSubmit} disabled={isPending || rozsahNeplatny}>
                    {isPending && <CircularProgress size={20} sx={{ mr: 1 }} />}
                    Odhlásit vozidlo
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DostupnostTechnikaDialog;
